import { encodedStringParser, numberParser } from '../inboundParsers';
export const SHOW_JACKS_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'page', parser: encodedStringParser },
        { name: 'giveConfirmToPlayerId', parser: numberParser },
        { name: 'giveConfirmToUsername', parser: encodedStringParser },
        { name: 'giveConfirmNumJacks', parser: numberParser },
        { name: 'giveConfirmNumJacksRequired', parser: numberParser },
        { name: 'giveDefaultUsername', parser: encodedStringParser },
        { name: 'taxPercent', parser: numberParser },
        { name: 'numFreeJacksGivenMonthly', parser: numberParser }
    ]
};
